module.exports = __webpack_public_path__ + "static/sidebar-background-c1c161dd30691dcfedcfe4c22e879f35.jpg";